export enum RolesEnum {
    Admin = 'Admin',
    Employee = 'Employee',
    Customer = 'Customer',
}